<!-- Show loading component while promo status is being checked -->
@if (isPromoStatusLoading()) {
	<app-loading />
} @else {
	<!-- Main router outlet for layout components -->
	<router-outlet />
}
